export default __webpack_public_path__ + "static/media/vidimg.ad44a06a.svg";